import React, { FC } from 'react';
import { useFormikContext } from 'formik';

import { getPhoto, hasPhoto, hasUrl, hasVideo, getVideo, getUrl } from 'features/content/helpers';

import { ContentInput } from 'api';
import { UserGroup } from 'types/app';

import { RemoveTypes } from '../types';
import { Photo as PhotoPreview, Url as UrlPreview, Video as VideoPreview } from './PreviewPartials';

interface IProps {
  working?: boolean;
  onRemove?: (type: RemoveTypes) => () => void;
  selectedGroup: UserGroup;
}

const Preview: FC<IProps> = ({ working, onRemove, selectedGroup }) => {
  const { values } = useFormikContext<ContentInput>();

  function renderPhotoPreview() {
    const photo = getPhoto(values);

    return <PhotoPreview photo={photo} onRemove={onRemove} />;
  }

  function renderVideoPreview() {
    const video = getVideo(values);

    return <VideoPreview working={working} video={video} onRemove={onRemove} />;
  }

  if (hasVideo(values)) {
    return renderVideoPreview();
  }

  if (hasPhoto(values)) {
    return renderPhotoPreview();
  }

  if (hasUrl(values)) {
    return <UrlPreview selectedGroup={selectedGroup} onRemove={onRemove} url={getUrl(values)} />;
  }

  return null;
};

export default Preview;
